// Single source of truth for the canonical public origin.
// Every canonical URL, og:url, sitemap entry and JSON-LD URL must derive from this.
export const SITE_URL = 'https://careerbuddy.pro';
export const SITE_NAME = 'CareerBuddyPro';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;
export const DEFAULT_DESCRIPTION =
  'CareerBuddyPro connects world-class African professionals with global companies. Find verified developers, designers, and marketers with payment protection.';

// Normalise a router pathname to the key used in seo-config: no query/hash,
// no duplicate or trailing slashes.
export const normalizePath = (pathname = '/') => {
  const path = String(pathname).split(/[?#]/)[0].replace(/\/{2,}/g, '/');
  return path.length > 1 ? path.replace(/\/+$/, '') : '/';
};

// Build an absolute, canonical URL from a router pathname, so that `/about`,
// `/about/` and `/about?ref=x` all produce a single canonical.
export const absoluteUrl = (pathname = '/') => `${SITE_URL}${normalizePath(pathname)}`;
